// SidebarItems.ts

import { useState } from "react";

// Step 1: Define the interface for the object structure
// interface SidebarItem {
//   label: string;      // Display label
//   dropdown?: string[]; // Optional dropdown items (array of strings)
//   link?: string;
//   privileges?: any;
// }

interface DropdownItem {
  option: string;
  path: string;
  privilege: any;
}

interface SidebarItem {
  label: string;      // Display label
  dropdown?: string[] | DropdownItem[]; // Optional dropdown items
  link?: string;
  privileges?: any;
}

// Step 2: Create the object
export const sidebarObj: SidebarItem[] = [
  {
    label: "Dashboard",
    privileges: "allowed",
  },
  {
    label: "Admin Management",
    link: "/admin-management/list-of-admins",
    privileges: "supper-admin-allowed",
  },
  {
    label: "User Management",
    dropdown: [
      {
        option: "Master Distributor Management",
        path: "/user-management/master-distributor-management",
        privilege: ["MDM1", "MDM4"],
      },
      {
        option: "Distributor Management",
        path: "/user-management/distributor-management",
        privilege: ["DM1", "DM4"],
      },
      {
        option: "Sub Distributor Management",
        path: "/user-management/sub-distributor-management",
        privilege: ["SDM1", "SDM4"],
      },
      {
        option: "Agent Management",
        path: "/user-management/agent-management",
        privilege: ["AM1", "AM4"],
      },
      {
        option: "Retailer Management",
        path: "/user-management/retailer-management",
        privilege: ["RM1", "RM2", "RM3", "RM4", "RM5"],
      },
      {
        option: "Customer Management",
        path: "/user-management/customer-management",
        privilege: ["CM1", "CM2", "CM3", "CM4", "CM5"],
      },
    ],
    privileges: [
      "MDM1",
      "MDM4",
      "SDM1",
      "SDM4",
      "DM1",
      "DM4",
      "AM1",
      "AM4",
      "RM1",
      "RM4",
    ],
  },
  {
    label: "Services",
    dropdown: [
      {
        option: "Recharge",
        path: "/services/recharge",
        privilege: "S1",
      },
      {
        option: "Bundle Activation",
        path: "/services/bundle-activation",
        privilege: "S2",
      },
    ],
    privileges: ["S1", "S2"],
  },

      {
    label: 'Support',
   link: '/support/list-tickets',
    privileges: "allowed",
  },
  // {
  //   label: 'Transactions',
  //   dropdown: ["Raise Cash In", "Raise Cash Out", "Cash In Request", "Cash Out", "Request"]
  // },
  {
    label: "MNO Management",
    link: "/mno-management/list-of-mnos",
    privileges: ["MM1", "MM4"],
  },
  {
    label: "Onboarding / Modification Request",
    link: "/onboarding-request/onboarding",
    privileges: ["OR1", "OR2", "OR3", "OR4"],
  },
  {
    label: "Company Management",
    privileges: ["CMGT1", "CMGT4"],
  },
  {
  label: 'Bulk Transfer',
  link: '/bulk-transfer',
  privileges: "allowed",
},
  // {
  //   label: 'Support'
  // },
  {
    label: 'Reports',
    link: "/reports/etopup-recharge",
    privileges: ["R1", "R2", "R3", "R4", "R5", "R6", "R7", "R8", "R9", "R10", "R11", "R12", "R13", "R14", "R15", "R16", "R17", "R18", "R19", "R20", "R21", "R22"],
  },
  {
    label: "Zoodpay Money",
    dropdown: [
      {
        option: "Balance Sheet",
        path: "/zoodpay-money/balance-sheet",
        privilege: "allowed",
      },
      {
        option: "Journal Voucher",
        path: "/zoodpay-money/journal-voucher",
        privilege: "allowed",
      },
      {
        option: "Super Admin Transactions",
        path: "/zoodpay-money/super-admin-transactions",
        privilege: "supper-admin-allowed",
      },
      {
        option: "Reversals",
        path: "/zoodpay-money/reversals/recharge-reversal",
        privilege: "allowed",
      },
      {
        option: "Upfront Service Fee",
        path: "/zoodpay-money/upfront-service-fee",
        privilege: "allowed",
      },
      {
        option: "CVM Service Fee",
        path: "/zoodpay-money/cvm-service-fee",
        privilege: "allowed",
      },
      {
        option: "Zoodpay Recovery Account",
        path: "/zoodpay-money/zoodpay-recovery-account",
        privilege: "supper-admin-allowed",
      },
    ],
    privileges: "allowed",
  },
  {
    label: "Other Resources",
    dropdown: [
      { option: "Banks", path: "/other-resources/banks", privilege: "allowed" },
      {
        option: "Regional Offices",
        path: "/other-resources/regional-offices",
        privilege: "allowed",
      },
    ],
    privileges: "allowed",
  },
  {
    label: "Reversal Requests",
    link: "/reversal-requests",
    privileges: ["RR1", "RR2", "RR3"],
  },
  // {
  //   label: "Raise E Top Up Request",
  //   link: "/raise-e-top-up-request/raise",
  //   privileges: "admin-allowed",
  // },
  {
    label: "E Top Up Request",
    link: "/e-top-up-request/e-top-up",
    privileges: "allowed",
  },
  {
    label: "Logs",
    link: "/logs/user-activity-logs",
    privileges: "allowed",
  },

];
